import { Fragment } from "react";
import { containerClasses } from "../../styles/containers";
import { Text } from "./Text";
import { Stack } from "./Stack";
import { AlertBox } from "./alert";
import { Button } from '../FormControls/Button';
import { ScreenControl } from "../app/ScreenControl";
import { ArrowBackIos, AccountBalance, Receipt } from '@mui/icons-material'
import { useDispatch } from 'react-redux';
import { jump } from "../../../main/slices/routerSlice";
import { useCookies } from "react-cookie";
import { useState, useEffect } from "react";

const RenderList = ({ classes, items, onSelect }) => {
    const contClass = containerClasses();
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null);
    const [cookies, setCookies] = useCookies(["source", "idTrxEditing"]);

    // ALERT
    const [showAlert, setShowAlert] = useState(false); // view alert
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [alertTitle, setAlertTitle] = useState(null);

    // CLOSE ALERT MESSAGE
    const handleCloseAlert = () => setShowAlert(false);

    const handleItemChange = (item) => {
        setCookies("detalleTrx", false)
        setSelected(item.id);
        onSelect(item.id);
    }
    classes = classes.reduce((cls, c) => cls + " " + contClass[c], "");

    function mapEstado(estado, mined) {
        const estadoMap = {
            "new": "Nueva",
            "expired": "Expirada",
            "completed": "Completada",
            "rejected": "Rechazada",
            "New": "Nueva",
            "Expired": "Expirada",
            "Completed": "Completada",
            "Rejected": "Rechazada"
        };
    
        return !mined ? "Procesando" : estadoMap[estado] || "Desconocido";
    }

    function mapOperation(op) {
        const estadoMap = {
            "Venta en Efectivo": "Venta",
            "Canje Gift Card": "Retiro en tienda",
            "Retiro": "Retiro en cajero"
        };
        return estadoMap[op] || "Depósito bancario";
    }

    function mapAmount(item, type, giftCard) {
        if(type == "Retiro") return item.Transaction_Deposit_Total;
        return (item.Transaction_Deposit_Total * item.Transaction_Exchange_Rate_Country)
    }

    const editBankData = (trx) => {
        // SAVE ID TRX IN COOKIES 
        setCookies("idTrxEditing", trx.id);
        return true
    }
    
    useEffect(() => {
        if (cookies.idTrxEditing && cookies.idTrxEditing !== "" && !selected) {
          setSelected(cookies.idTrxEditing);
          setCookies("idTrxEditing", "");
        }
    }, [cookies.idTrxEditing, selected]);

    if(!items.length || items.length==0){
        return (
            <>  
                <Fragment>
                    <Text classes={["center","mediumText", "alignContent"]}>Aún no tienes transacciones.</Text>
                </Fragment>
                <Button 
                    style={{
                        position: "fixed",
                        top: "1.5rem",
                    }} 
                    classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
                    onClick={() => dispatch(jump({ current: 8, direction: "backward" })) }>
                    <ArrowBackIos  fontSize='small' />
                </Button>
            </>
        );
    }

    if(selected){
        const item = items.filter((e) => e.id == selected)[0];
        return (
            <>
                <Fragment>
                    {/* ALERT */}
                    {showAlert && (
                        <AlertBox
                        message={`${alertMessage}`}
                        type={alertType}
                        title={alertTitle}
                        onClose={handleCloseAlert}
                        />
                    )}
                    <div style={{ padding: "0 2.5rem" }}>
                        <Stack flex={{ flexDirection: "column", gap: 0.05, overflowY: "scroll" }}>
                            <Text classes={["title", "center"]}> Detalles de la transacción </Text>
                            {/* Detalle transaccion */}
                            <ScreenControl
                                index={{ fw: -1 }}
                                disabled={false}
                                parentClasses={["cardOption", "marginTB1em", "cursorNormal"]}
                                >
                                <Text classes={["smallTitle"]} style={{ color: "#000", textAlign: "center" }}>
                                    {`id: ${ item.id }`}
                                </Text>
                                <Stack flex={{ flexDirection: "row", alignItems: "center" }} >
                                    <Stack flex={{ flexDirection: "Column", display: "flex", alignItems: "center", width: "10rem" }}>
                                        <Receipt
                                            sx={{
                                            paddingLeft: "35px",
                                            paddingRight: "25px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "3.5rem",
                                            marginRight: "10px",
                                            color: "#000",
                                            }}
                                        />
                                        <Text classes={["subtitle"]} style={{ color: "#000", textAlign: "center" }}>
                                            {mapOperation(item.Bank_Account_Type || item.Transaction_Type)}
                                        </Text>
                                    </Stack>
                                    <Stack flex={{ flexDirection: "Column", display: "flex", alignItems: "start" }}>                            
                                        <>
                                            <br />
                                            <Text classes={["smallTitle"]} style={{ color: "#000" }}>
                                                Estado: {mapEstado(item.Transaction_Status, item.Transaction_Worldchain_Mined)}
                                            </Text>
                                            <Text classes={["smallTitle"]} style={{ color: "#000" }}>
                                                Total enviado: {item.Transaction_Crypto_Currency} {parseFloat(item.Transaction_Crypto_Amount).toFixed(2)}
                                            </Text>
                                            <Text classes={["smallTitle"]} style={{ color: "#000" }}>
                                                Total a {item.Transaction_Type != "Retiro" ? "recibir" : "retirar"}: {item.Transaction_Deposit_Currency} {Math.floor(parseFloat(mapAmount(item, item.Transaction_Type, item.Transaction_Gift_Card || null)).toFixed(2))}.00
                                            </Text>
                                            <br />
                                        </>
                                    </Stack>
                                </Stack>
                            </ScreenControl>
                            
                            {/* DATOS BANCARIOS */}
                            {(item.Transaction_Type != "Retiro" && item.Bank_Account_Type!="Venta en Efectivo" && item.Bank_Account_Type!="Canje Gift Card")? (
                                <>
                                <ScreenControl
                                    index={{ fw: -1 }}
                                    disabled={false}
                                    parentClasses={["cardOption", "marginTB1em", "cursorNormal"]}
                                    >
                                    <Stack flex={{ flexDirection: "row", alignItems: "center" }} >
                                        <Stack flex={{ flexDirection: "Column", display: "flex", alignItems: "center", width: "40%",  margin: "auto 1em" }}>
                                        <AccountBalance
                                            sx={{
                                            paddingLeft: "35px",
                                            paddingRight: "25px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "3.5em",
                                            marginRight: "10px",
                                            color: "#000",
                                            }}
                                        />
                                        <Text classes={["subtitle"]} style={{ color: "#000", textAlign: "center" }}>
                                            {item.Bank_Name ?? ""} 
                                        </Text>
                                        </Stack>
                                        <Stack flex={{ flexDirection: "Column", display: "flex", alignItems: "start" }}>                                <>
                                            <Text classes={["subtitle"]} style={{ color: "#000", fontWeight: "bold" }}>
                                                Datos bancarios
                                            </Text>
                                            <Text classes={["smallTitle"]} style={{ color: "#000",  }}>
                                                Nombre: {item.Bank_Account_Name}
                                            </Text>
                                            <Text classes={["smallTitle"]} style={{ color: "#000",  }}>
                                                Número: {item.Bank_Account_Number}
                                            </Text>
                                            <Text classes={["smallTitle"]} style={{ color: "#000", }}>
                                                Moneda: {item.Bank_Account_Currency}
                                            </Text>
                                            <Text classes={["smallTitle"]} style={{ color: "#000", }}>
                                                Tipo: {item.Bank_Account_Type}
                                            </Text>                                        
                                            </>
                                        </Stack>
                                    </Stack>
                                </ScreenControl>
                                {item.Transaction_Status == "Rechazada" && item.Bank_Data_Declined && !item.Transaction_Modified ?(
                                    <ScreenControl
                                        index={{ fw: 20 }}
                                        disabled={false}
                                        btnText={"Editar datos bancarios"}
                                        beforeSubmit={() => editBankData(item)}
                                    >
                                    </ScreenControl>
                                ):""}
                                </>
                            ):""}

                        </Stack>
                    </div>
                </Fragment>
                <Button 
                    style={{
                        position: "fixed",
                        top: "1.5rem",
                    }}
                    classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
                    onClick={() => {
                        setCookies("detalleTrx", true)    
                        setSelected(null)} 
                    }>
                    <ArrowBackIos  fontSize='small' />
                </Button>
            </>
        );
    }

    return (
        <>
            <Fragment>
                <div style={{ width: "105%", height: "25rem", overflowY: "scroll"}}>
                    {items.map((item, i) =>
                        <div key={i} onClick={() => handleItemChange(item)} className={`${contClass.listTransactions} ${item.id === selected ? contClass.selectedItem : ""}`}>
                            <div className={contClass.width100}>
                                <Text classes={["annotation"]}>{(new Date(item.Transaction_TimeStamp)).toLocaleDateString('es-ES', {
                                    weekday: 'long', // Día de la semana completo (martes)
                                    day: '2-digit',  // Día con dos dígitos (10)
                                    month: 'long',   // Nombre completo del mes (diciembre)
                                    year: 'numeric', // Año (2024)
                                    timeZone: 'GMT'  // Asegura que sea en GMT
                                })}</Text>
                                <Text classes={["mediumText"]}>{mapOperation(item.Bank_Account_Type || item.Transaction_Type)}</Text>
                            </div>
                            <div className={contClass.maxWidth20} style={{textAlign: "right", whiteSpace: "nowrap"}}>
                                <Text classes={["annotation"]}>{mapEstado(item.Transaction_Status, item.Transaction_Worldchain_Mined)}</Text>
                                <Text classes={["mediumText"]}>{item.Transaction_Deposit_Currency || item.Transaction_Currency} {Math.floor(parseFloat(mapAmount(item, item.Transaction_Type, item.Transaction_Gift_Card || null)).toFixed(2))}.00</Text>
                                <Text classes={["annotation"]}>{item.Transaction_Crypto_Currency} {parseFloat(item.Transaction_Crypto_Amount).toFixed(2)}</Text>
                            </div>
                        </div>
                    )}
                </div>
            </Fragment>                                                         
            <Button 
                style={{
                    position: "fixed",
                    top: "1.5rem",
                }} 
                classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
                onClick={() => dispatch(jump({ current: 8, direction: "backward" })) }
            >
                <ArrowBackIos />
            </Button>
        </>
    );
}

export const List = ({ classes = [], items = [], onSelect = () => {} }) => (
    <RenderList {...{ classes, items, onSelect }} />
);